import Select from 'shared/components/Select'
import * as grs from 'grs'

import { getTransactionStatuses } from 'shared/transactions'

import { statusSelector, areAllVisibleSelector } from '../selectors'
import { setStatusFilter, getReservations, getMoreReservations } from '../actions'
import WaitingListTable from './WaitingListTable'
import ReservationsTable from './ReservationsTable'

const OPTION_LABEL_MAP = {
    [grs.constants.STATUS_ACTIVE]: 'dashboard.label.active',
    [grs.constants.STATUS_PASSED]: 'dashboard.label.passed',
    [grs.constants.STATUS_CANCELLED]: 'dashboard.label.cancelled',
    [grs.constants.STATUS_WAITING_LIST]: 'dashboard.label.waitingList',
}

const OPTIONS = getTransactionStatuses().map(value => ({
    value,
    label: <T>{OPTION_LABEL_MAP[value]}</T>,
}))

const Filters = ({ value, onChange }) => (
    <div className="row justify-content-md-center align-items-center">
        <div className="col-sm-auto text-right">
            <T>dashboard.label.filterText</T>
        </div>
        <div className="col-sm-3">
            <Select options={OPTIONS} value={OPTIONS.find(option => option.value === value)} onChange={onChange} />
        </div>
    </div>
)

class Reservations extends Component {
    constructor(props) {
        super(props)

        this.onFilterChange = this.onFilterChange.bind(this)
    }

    componentDidMount() {
        this.props.getReservations()
    }

    onFilterChange({ value }) {
        this.props.setStatusFilter(value)
    }

    render() {
        const { status, areAllVisible, onSelectReservation, getMoreReservations } = this.props

        return (
            <div>
                <Filters onChange={this.onFilterChange} value={status} />

                {status === grs.constants.STATUS_WAITING_LIST ? (
                    <WaitingListTable />
                ) : (
                    <ReservationsTable onSelectReservation={onSelectReservation} />
                )}

                {!areAllVisible && (
                    <div className="show-more">
                        <button className="btn btn-outline-primary" onClick={getMoreReservations}>
                            <T>dashboard.label.show.more</T>
                        </button>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    status: statusSelector,
    areAllVisible: areAllVisibleSelector,
})

const mapDispatchToProps = {
    setStatusFilter,
    getReservations,
    getMoreReservations,
}

export default connect(mapStateToProps, mapDispatchToProps)(Reservations)
